<template>
  <div>
  <div class="wrapper sl-wrapper">

    <side-bar-sl>
      <template slot="links">
         <sidebar-sl-item
          :link="{
            name: $t('sl.menu.home'),
            path: '/meetup',
            iconblack: './img/icons/sl/home_black.png',
            iconwhite: './img/icons/sl/home_white.png'
          }">
        </sidebar-sl-item>
        <sidebar-sl-item
          :link="{
            name: $t('sl.menu.itandxpdigitale'),
            path: '/slitdigitalexperience',
            iconblack: './img/icons/sl/IT_digital_black.png',
            iconwhite: './img/icons/sl/IT_digital_white.png'
          }">
        </sidebar-sl-item>
        <sidebar-sl-item
          :link="{
            name: $t('sl.menu.infrastructure'),
            path: '/slinfrastructurecybersecurity',
             iconblack: './img/icons/sl/infrastructure_cyber_security_black.png',
            iconwhite: './img/icons/sl/infrastructure_cyber_security_white.png'
          }">
        </sidebar-sl-item>
        <sidebar-sl-item
          :link="{
            name: $t('sl.menu.si'),
            path: '/slintelligentsystems',
            iconblack: './img/icons/sl/intelligent_systems_black.png',
            iconwhite: './img/icons/sl/intelligent_systems_white.png'
          }">
        </sidebar-sl-item>

        <b-navbar-nav  class="mobile-admin-nav align-items-lg-center ml-lg-auto d-block d-lg-none">
          <b-nav-item>
              <span class="nav-link-inner--text" @click="setLanguage('fr')" :class="[language == 'fr'? 'language active':'language']">{{ $t('language.fr') }}</span>
              |
              <span class="nav-link-inner--text" @click="setLanguage('en')" :class="[language == 'en'? 'language active':'language']">{{ $t('language.en') }}</span>
              |
              <span class="nav-link-inner--text" @click="setLanguage('pl')" :class="[language == 'pl'? 'language active':'language']">{{ $t('language.pl') }}</span>
          </b-nav-item>          
        </b-navbar-nav> 
        
      </template>
      <div class="copyright language-sl d-none d-lg-block">
        <span class="nav-link-inner--text" @click="setLanguage('fr')" :class="[language == 'fr'? 'language active':'language']">{{ $t('language.fr') }}</span>
         | 
        <span class="nav-link-inner--text" @click="setLanguage('en')" :class="[language == 'en'? 'language active':'language']">{{ $t('language.en') }}</span>
         | 
        <span class="nav-link-inner--text" @click="setLanguage('pl')" :class="[language == 'pl'? 'language active':'language']">{{ $t('language.pl') }}</span>
      </div>
    </side-bar-sl>
    
    <div class="main-content">
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
    
  </div>
    <user-footer class="footer-sl"></user-footer>
  </div>

</template>
<script>
  import Vue from "vue";
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import UserFooter from "./UserFooter";

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import AdminNavbar from './AdminNavbar.vue';
  import AdminContent from './AdminContent.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      AdminNavbar,
      AdminContent,
      FadeTransition,
      UserFooter
    },
    data() {
      return {
          language: Vue.i18n.locale(),
          year: new Date().getFullYear()
      };
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      },
      setLanguage (locale) {
        Vue.i18n.set(locale);
        this.language = locale;
        localStorage.setItem(Vue.Keys.LANGUAGE, locale);
        this.$router.go();
      }      
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
</style>
